module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"side-nav":{"login":"Login"},"main-nav":{"recent":"Recent","favorite":"Favorites"}},"de":{"side-nav":{"login":"Login"},"main-nav":{"recent":"Vorherige","favorite":"Favoriten"}}}')
  delete Component.options._Ctor
}
